<template>
  <div class="gmap">
    <img :src="src" alt="Map">
  </div>
</template>

<script>
  export default {
    props: ['src']
  }
</script>

<style scoped lang="scss">
  .gmap img {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// app/javascript/components/static-map.vue?86eca234